<template>
  <div>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab active-class="tab" ripple>{{ $t("accountingPage.tabPending") }}</v-tab>
      <v-tab active-class="tab" ripple>{{ $t("accountingPage.tabDone") }}</v-tab>

      <v-tab-item>
        <TransferCenterPendingPayments v-if="active === 0" />
      </v-tab-item>

      <v-tab-item>
        <TransferCenterDonePayments v-if="active === 1" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import TransferCenterDonePayments from "@/views/accounting/TransferCenterDonePayments";
import TransferCenterPendingPayments from "@/views/accounting/TransferCenterPendingPayments";

export default {
  name: "TransferCentersAccounting",
  title() {
    return this.$t("accountingPage.transferCentersAccountingTitle");
  },
  components: {
    TransferCenterPendingPayments,
    TransferCenterDonePayments
  },
  data() {
    return {
      active: 0,
    };
  },
};
</script>

<style scoped>
.tab {
  color: #e21024 !important;
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}
</style>
